export const updateAppName = (state, payload) => { state.appName = payload; }
export const updateUser = (state, payload) => { state.user = payload; }
export const updateSelectedUser = (state, payload) => { state.selected_user = payload; }
export const updateLoading = (state, payload) => { state.loading = payload; }
export const updateErrors = (state, payload) => { state.errors = payload; }
export const updateStorageDir = (state, payload) => { state.storageDir = payload; }